// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13ae9478","732":"c7c4b7c1","977":"105696c2"}[chunkId] + ".chunk.js";
};